import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {
  PreloadAllModules,
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
  withPreloading,
  withRouterConfig,
} from '@angular/router';
import { CoreModule } from '@core/core.module';
import { APP_ROUTES } from './app.routes';
import { langInterceptor } from '@core/interceptors/lang.interceptor';
import { authInterceptor } from '@core/interceptors/auth.interceptor';
import { loadingInterceptor } from '@core/interceptors/loading.interceptor';
import { errorInterceptor } from '@core/interceptors/error.interceptor';
import { provideAuth } from 'angular-auth-oidc-client';
import { authConfig } from './auth/auth.config';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { impersonationInterceptor } from '@core/interceptors/impersonation.interceptor';
import { provideResizeOptions } from 'ngxtension/resize';
import { unauthorizedInterceptor } from '@core/interceptors/unauthorized.interceptor';
import { countryInterceptor } from '@core/interceptors/country.interceptor';

export const APP_CONFIG: ApplicationConfig = {
  providers: [
    provideRouter(
      APP_ROUTES,
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
      }),
      withRouterConfig({
        paramsInheritanceStrategy: 'always',
        onSameUrlNavigation: 'reload',
      }),
      withComponentInputBinding(),
      withPreloading(PreloadAllModules)
    ),
    importProvidersFrom(BrowserModule, CoreModule),
    provideAuth(authConfig),
    provideHttpClient(
      withInterceptors([
        langInterceptor,
        authInterceptor,
        countryInterceptor,
        loadingInterceptor,
        errorInterceptor,
        impersonationInterceptor,
        unauthorizedInterceptor,
      ])
    ),
    provideAnimationsAsync(),
    provideResizeOptions({
      box: 'content-box',
      scroll: false,
      offsetSize: false,
      debounce: { scroll: 50, resize: 50 },
      emitInZone: true,
      emitInitialResult: true,
    }),
  ],
};
